import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

const EXPIRATION_TIME_ONE_MONTH = 30 * 24 * 60 * 60 * 1000;

@Injectable()
export class SmartLocalStorageService {
	entry: any;
	localStorageUser: Subject<string> = new BehaviorSubject<string>(null);

	constructor() {
		const user = this.getLocalStorage('c-user');
		this.updateLocalStorageUser(user);
	}

	getLocalStorage(key: string): any {
		const entry = JSON.parse(localStorage.getItem(key) || '0');

		if (this.isExpired()) {
			this.deleteLocalStorage(key);
		}

		return this.isUser(entry && entry._value) ? entry._value : null;
	}

	setLocalStorage(key: string, _value: any): void {
		localStorage.setItem(
			key,
			JSON.stringify({
				expiration: new Date().getTime() + EXPIRATION_TIME_ONE_MONTH || 0,
				_value
			})
		);

		this.entry = {
			expiration: new Date().getTime() + EXPIRATION_TIME_ONE_MONTH || 0,
			_value
		};
		this.updateLocalStorageUser(_value);
	}

	deleteLocalStorage(key: string): void {
		localStorage.removeItem(key);
		this.entry = null;
		this.localStorageUser.next(null);
	}

	isUser(user: any): boolean {
		return !!user;
	}

	isExpired(): boolean {
		return Boolean(this.entry && this.entry.expiration && new Date().getTime() > this.entry.expiration);
	}

	updateLocalStorageUser(user) {
		if (!user) {
			return;
		}
		this.localStorageUser.next(user);
	}
}

export interface User {
	email: string;
	userId: number;
	uuid: string;
	role: string;
	workingAs?: boolean;
	originalUser?: object;
	jwt?: string;
}
